import React from "react";
import { Card } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { updateStatus } from "../../redux/surveySlice";
import CtaGroup from "../baseui/buttons/CtaGroup";
import TableSurveyList from "./TableSurveyList";

const SurveyList = ({ survey, getSurveys, paginate }) => {
  const dispatch = useDispatch();

  const updateSurveyStatus = async (props, status) => {
    dispatch(
      updateStatus({
        id: props.row.original.id,
        pageNum: props.initialState.pageNumber,
        status,
        clientRef: null,
      })
    );
  };

  return (
    <>
      <Card className="card-main p-0 ">
        <Card.Title className="d-flex mb-0">
          <h5 className="mb-0">List of surveys</h5>
          <div className="ms-auto">
            <CtaGroup link="/surveys" ctaText="View All" />
          </div>
        </Card.Title>
        <Card.Body>
          <div className="surveysContent">
            <TableSurveyList
              survey={survey}
              getSurveys={getSurveys}
              paginate={paginate}
              statusUpdate={updateSurveyStatus}
            />
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default SurveyList;
